var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsgboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-88 -610) translate(40 609) translate(48 1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.292 4C19.788 4 21 5.212 21 6.708v8.987c0 1.496-1.212 2.708-2.708 2.708H7.882l-3.328 3.329C3.98 22.305 3 21.899 3 21.088V6.708C3 5.212 4.212 4 5.708 4h12.584zm0 1.498H5.708c-.49 0-1.08.808-1.08 1.298v12.391l2.234-2.13c.17-.17.402-.267.644-.267h10.786c.49 0 1.048-.397 1.048-.887V6.708c0-.49-.558-1.21-1.048-1.21zm-5.206 6.824c.517 0 .936.2.936.702 0 .503-.419.784-.936.784H7.88c-.518 0-.937-.281-.937-.784s.42-.702.937-.702zm3.048-3.367c.51 0 .922.253.922.756s-.413.744-.922.744H7.866c-.51 0-.922-.241-.922-.744s.413-.756.922-.756z",
    transform: "translate(-88 -610) translate(40 609) translate(48 1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgboard);
export default __webpack_public_path__ + "static/media/msgboard.e148581f.svg";
export { ForwardRef as ReactComponent };